import { useAuth, useCurrentDialog } from "@/GlobalData";
import M3ripple from "@/common/components/m3ripple";
import { signOut } from "firebase/auth";

export function SignOut() {
    const currentDialog = useCurrentDialog();
    const auth = useAuth();
    const handleSubmit = async () => {
        // This function only runs if all HTML validations pass
        await signOut(auth.auth);
        currentDialog.hideDialog()
    };
    return <div className="w-full inline-flex flex-col justify-start items-start gap-2.5 overflow-hidden">
        <div className="self-stretch justify-start text-stone-500 text-base font-normal font-['Be_Vietnam_Pro'] leading-normal">Ketika anda keluar, anda harus ketik email dan password lagi untuk masuk</div>
        <div className="self-stretch flex-1 py-2.5 inline-flex justify-start items-start gap-2.5 overflow-hidden">
            <div className="flex-1 px-3.5 py-3 bg-neutral-100 rounded-md outline outline-1 outline-offset-[-1px] outline-teal-900 flex justify-between items-center relative">
                <div className="justify-start text-teal-900 text-lg font-normal font-['Be_Vietnam_Pro']">Batal</div>
                <M3ripple />
            </div>
            <button className="flex-1 px-3.5 py-3 bg-red-400 rounded-md outline outline-1 outline-offset-[-1px] outline-red-600 flex justify-between items-center relative" onClick={async () => {
                await handleSubmit();
            }}>
                <div className="justify-start text-white text-lg font-normal font-['Be_Vietnam_Pro']">Keluar</div>
                <M3ripple />
            </button>
        </div>
    </div>;
}